import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";

import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import "./MAgregarPersona.css";

function MAgregarPersona({
  origenComponente,
  registro = {},
  parametros,
  tipoEvento,
  fCerrarComponente,
  fEstablecerVariablesTabla,
  fActualizarTablaTotal,
  modo, //solo disponible para agregar persona
}) {
  const { ecv_u, cv_u } = useContext(Contexto);
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });
  const [v_u, ev_u] = useState({
    form: null,
    datosForm: {},
    respuestaActualizacion: {},
  });
  const [actualizaDatosTabla, setactualizaDatosTabla] = useState(null);

  useEffect(() => {
    console.log(origenComponente, registro, parametros, tipoEvento);
    console.log("primera validacion: ", registro?.codigo ?? "");
    const personaCrud = _api_.f_personasCRUD({
      parametros: {
        modo: "DSF",
        codigoPersona: registro?.codigo ?? 0,
        persona: v_u.datosForm,
      },
      timeout: 5000,
    });
    personaCrud.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      // console.log(dPC.contenido.datos);
      if (!dPC.error) {
        console.log(_f_.descomprimirDatos(dPC.contenido.datos));
        _f_.asignar(ev_u, {
          form: _f_.descomprimirDatos(dPC.contenido.datos).form,
        });
      }
    });
  }, []);

  const datosPersonaApi = (variables) => {
    console.log(variables);
    if (
      variables.ndoc.length > 0 &&
      variables.ndoc.length <= 8 &&
      variables.tdoc === "1"
    ) {
      const formPersona = _api_.f_personasCRUD({
        parametros: {
          modo: "DSR",
          codigoPersona: registro?.codigo ?? 0,
          persona: v_u.datosForm,
        },
        timeout: 5000,
      });

      formPersona.respuesta.then((dPC) => {
        _f_.asignar(ecv_u, dPC, true, origenComponente);
        if (!dPC.error) {
          actualizaDatosTabla("nombre", dPC.contenido.nombre);
          actualizaDatosTabla("apePat", dPC.contenido.apePat);
          actualizaDatosTabla("apeMat", dPC.contenido.apeMat);
        }
      });
    }
  };

  useEffect(() => {
    // console.log(v_u.datosForm);
  }, [v_u.datosForm]);

  return (
    <div className={"MAgregarPersonaCSS-cuerpo"}>
      {v_c.modal_mostrar && (
        <ModalInformacion
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: false,
            });
          }}
        >
          {v_c.preConfirmar_mostrar && (
            <_preconf_.PreConfirmacion
              texto="¿Seguro que desea confirmar los cambios?"
              fBotonAceptar={() => {
                const actualizarDatosAPI = _api_.f_personasCRUD({
                  parametros: {
                    modo: registro?.codigo ? "UPD":"INS",
                    codigoPersona: registro?.codigo ?? 0,
                    persona: v_u.datosForm,
                  },
                  timeout: 5000,
                });

                actualizarDatosAPI.respuesta.then((dPC) => {
                  _f_.asignar(ecv_u, dPC, true, origenComponente);
                  console.log(dPC);
                  if (!dPC.error) {
                    _f_.asignar(ev_c, {
                      procesandoAccion_mostrar: false,
                      modal_titulo: "✅ Éxito",
                      postConfirmar_mostrar: true,
                    });
                    _f_.asignar(ev_u, {
                      respuestaActualizacion: dPC.contenido,
                    });
                  } else {
                    _f_.limpiarAsignacion(ev_c, Object.keys(v_c));
                  }
                });

                _f_.asignar(ev_c, {
                  preConfirmar_mostrar: false,
                  modal_titulo: "⏳ Procesando",
                  procesandoAccion_mostrar: true,
                });
              }}
              fBotonCancelar={() => {
                _f_.asignar(ev_c, { modal_mostrar: false });
              }}
            />
          )}
          {v_c.procesandoAccion_mostrar && <_procAcc_.ProcesandoAccion />}
          {v_c.postConfirmar_mostrar && (
            <_posconf_.PostConfirmacion
              texto={`Se guardo la información para ${registro?.["Nombres y Apellidos"]}`}
              fBotonDeAcuerdo={() => {
                fCerrarComponente?.();
                fActualizarTablaTotal?.(true);
              }}
            >
              <table border="1">
                <tbody>
                  <tr>
                    <th>Código de usuario</th>
                    <td>{v_u.respuestaActualizacion?.codigoUsuario}</td>
                  </tr>
                  <tr>
                    <th>Número de Documento</th>
                    <td>{v_u.respuestaActualizacion?.numeroDocumento}</td>
                  </tr>
                  <tr>
                    <th>Rol de Usuario</th>
                    <td>{v_u.respuestaActualizacion?.rol}</td>
                  </tr>
                  <tr>
                    <th>Contraseña</th>
                    <td>{v_u.respuestaActualizacion?.contrasenia}</td>
                  </tr>
                </tbody>
              </table>
            </_posconf_.PostConfirmacion>
          )}
        </ModalInformacion>
      )}
      <_form_.Formulario
        form={v_u.form ?? []}
        dext={setactualizaDatosTabla}
        onBlurCampos={{ ndoc: datosPersonaApi }}
        fObtenerDatosFormulario={(datos) => {
          _f_.asignar(ev_u, { datosForm: datos });
        }}
      ></_form_.Formulario>

      <div className={"MAgregarPersonaCSS-opciones"}>
        <_btn_.Boton
          texto={`${registro?.codigo ? "Actualizar Datos": "Aceptar"}`}
          tipo="btn-2"
          estilos={{
            anchoB2: "10rem",
            color: "var(--color_verde_1)",
            fuente: "1rem",
          }}
          onClick={() => {
            console.log(v_u.datosForm);
            _f_.asignar(ev_c, {
              modal_mostrar: true,
              modal_estilos: { anchoMI: "30rem" },
              modal_titulo: "❗Confirmar Acción",
              preConfirmar_mostrar: true,
            });
          }}
        />
        <_btn_.Boton
          texto={`Cancelar`}
          tipo="btn-2"
          estilos={{
            anchoB2: "10rem",
            color: "var(--color_rojo_1)",
            fuente: "1rem",
          }}
          onClick={() => {
            fCerrarComponente?.();
          }}
        />
      </div>
    </div>
  );
}
export default MAgregarPersona;
